import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=5f6862c4&scoped=true&"
import script from "./AddCategory.vue?vue&type=script&lang=js&"
export * from "./AddCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddCategory.vue?vue&type=style&index=0&id=5f6862c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6862c4",
  null
  
)

export default component.exports